<!--
 * @Author: chenyn 1826650603@qq.com
 * @Date: 2023-09-21 16:03:06
 * @LastEditors: chenyn 1826650603@qq.com
 * @LastEditTime: 2023-10-21 11:50:43
 * @FilePath: \smart-campus-platform-front-vue\src\views\homepage\course\study-list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="openclass-list ">
        <div class="course-video-con maxW">
            <nav-crumb :pathList="pathList" />
            <div class="tabs">
                <div v-for="(item, i) in statusTabs" :key="item.key" @click="switchTab(i)" >
                    <span style="cursor: pointer;" :class="{ 'acitvetab': checkIndex === i }">{{ item.name }}({{ item.count }})</span>
                </div>
            </div>
            <ul class="course-video-list clear">
                <li class="course-video-li box" v-for="(item, index) of videoListData" :key="index">
                    <div class="red_dot" v-if="item.is_update" />
                    <div class="speed" style="margin-bottom:-10px">
                        <!-- <el-tag type="danger">课程进度:{{ item.complete_task_count + '/' + item.total_task_count
                        }}</el-tag> -->

                        <el-tag :type="getTagType(item.task_status, item.complete_status)" effect="dark">
                            {{  item.task_status_txt }}
                        </el-tag>
                    </div>
                    <!-- <div class="status_tag" style="float: right;" v-if="item.complete_status">
                        <el-tag type="success" effect="dark">
                            已完成
                        </el-tag>
                    </div> -->
                    <div class="video-thumbnail">
                        <a @click="goToDetails(item)">
                            <img :src="item.picture.indexOf('http') == -1 ? BASE_URL + item.picture : item.picture"
                                :onerror="errorImg" />
                        </a>
                    </div>
                    <div class="video-creater-info">
                        <a @click="goToDetails(item)" style="font-weight:bold" :title="item.video_name">{{ item.name }}</a>
                        <div class="teacher-info clear">
                            <div style="font-size: 12px;"> {{ item.start_time.split(' ')[0].replace('-', '.') }}-{{
                                item.end_time.split(' ')[0].replace('-', '.') }}</div>
                            <div class=" ecmapper fr" :style="{ color: getStatuColor(item.task_status) }">
                                <!-- <div class=" ecmapper fr" > -->
                                <!-- 任务{{ item.task_status_txt }} -->
                                <!-- <el-tag :type="getTagType(item.task_status, item.complete_status)" effect="dark">
                                    {{ item.task_status_txt }}
                                </el-tag> -->

                                <div class="ecmapper fr" style="float: right;" v-if="item.complete_status">
                                    <el-tag type="primary" effect="dark">
                                    已完成
                                    </el-tag>
                                </div>
                                

                                <div  v-else class="ecmapper fr" style="margin-bottom:-10px">
                                    <el-tag type="danger">课程进度:{{ item.complete_task_count + '/' + item.total_task_count
                                    }}</el-tag>
                                </div>

                            </div>
                            <!-- <div class="ecmapper fr" style="margin-bottom:-10px">
                                <el-tag type="danger">课程进度:{{ item.complete_task_count + '/' + item.total_task_count
                                }}</el-tag>
                            </div> -->
                        </div>
                    </div>
                </li>
            </ul>
            <div class="pageBox">
                <el-pagination v-if="total_number > page_size" @current-change="change_page" :page-size="page_size"
                    :current-page="page_index" layout="total,prev, pager, next,jumper"
                    :total="total_number"></el-pagination>
            </div>
        </div>
        <div class="dependent maxW" v-if="placeholder">
            <i class="ipng image_state01"></i>
            <p>- {{ $t('global.noData') }} -</p>
        </div>
    </div>
</template>
  
<script>
import navCrumb from '@/components/common/navCrumb.vue';

export default {
    data() {
        return {
            pathList: [
                { path: '/homeindex', name: '首页' },
                { path: null, name: '学习任务' },],
            videoType: [],
            videoTypeId: 0, // 视频分类的高亮索引值
            placeholder: false,
            page_index: 1,
            page_size: 12,
            total_number: 0,
            keyword: this.$route.query.keyword, //首页搜索跳转到此页面时带的关键字
            errorImg:
                'this.src="' +
                require("../../../../public/images/image_loding.png") +
                '"',
            checked: false,
            videoListData: [],
            statusList: [  //task_status
                { key: 1, type: 'warning', name: '未开始', color: '#909399' },
                { key: 2, type: 'success', name: '进行中', color: '#409EFF' },
                { key: 3, type: 'danger', name: '即将结束', color: '#e6a23c' },
                { key: 4, type: 'info', name: '已结束', color: '#909399' },
                { key: 5, type: 'primary', name: '已完成', color: '#e62126' },
            ],
            statusTabs: [
                { key: 0, name: '全部', count: 0 },
                { key: 1, name: '未完成', count: 0 },
                { key: 2, name: '已完成', count: 0 },
                { key: 3, name: '未开始', count: 0 },
            ],
            checkIndex: 0
        };
    },
    computed: {
        isTencentCloud() {
            return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
        },
    },
    components: {
        CommonCate: () => import("@/components/common-v2/category.vue"),
        navCrumb
    },
    created() {
        this.getVideoData();
        this.getStatusAll()
        //改变头部导航 高亮
        this.$store.commit('SET_ACTIVEINDEX', 0)
    },
    watch: {
        "$store.state.customerCate": {
            handler: function(nv) {
                console.log("customerCate", nv);
                if (nv >= 0) {
                    this.videoTypeId = nv;
                    this.page_index = 1;
                    this.getVideoData();
                }
            },
        },

    },
    methods: {



        getStatusAll() {
            let success = (res) => {
                // this.videoListData = res.data.data;
                this.statusTabs[0].count = res.data.data.length
                res.data.data.forEach(r => {
                    // 未开始  就是task_status 未开始
                    if (r.task_status === 1 && !r.complete_status) {
                        this.statusTabs[3].count = this.statusTabs[3].count + 1
                    } 
                    // 未完成----进行中 已开始 + 完成状态为0的
                    if (!r.complete_status && (r.task_status >= 2)) {
                        this.statusTabs[1].count = this.statusTabs[1].count + 1
                    }
                    // 已完成    complete_status：1
                    if (r.complete_status) {
                        this.statusTabs[2].count = this.statusTabs[2].count + 1
                    }
                })
            };
            this.$ajax({
                url: "/api/assignment/assignment_list",
                method: "get",
                params: {
                    keyword: this.keyword,
                    page_index: this.page_index,
                    page_size: 99999,
                    user_id: this.$g.user_id,
                    is_limit: 1,
                    select_type: 0,
                },
                func: {
                    success,
                },
            });
        },
        switchTab(i) {
            this.checkIndex = i
            this.getVideoData()
            console.info(i)
        },
        getTagType(task_status, complete_status) {
            // if (complete_status) {
            //     return this.statusList[4].type
            // }
            if (task_status) return this.statusList.filter(r => r.key === task_status)[0].type
        },
        getStatuColor(task_status) {
            return this.statusList.filter(r => r.key === task_status)[0].color
        },
        // goToPath(path) {
        //     this.$router.push(path);
        // },

        celarRedDot(id) {
           let success = (res => {
                this.getVideoData()
            });
           let params={
             task_id:id,
             type:1,
             user_id:this.$g.user_id,
           }

           this.$ajax({
             url: "api/assignment/changeUpdate",
             method: "put",
             data: params,
             func: { success: success }
           });
        },

        // 跳转到任务目录详情页
        goToDetails(item) {
         
            this.celarRedDot(item.id)

            if (item.task_status === 1) {
                this.$message.warning(this.$t('global.test'));
                return
            }
            if (item.task_status === 4 ) {
                this.$message.warning(this.$t('global.testEnd'));
                return
            }
            this.$router.push({ path: 'studyDetail', query: { id: item.id } });


        },

        // 给每一个任务数量赋值
        setTaskTypeCount(length) {
            if(this.checkIndex === 0) return
            this.statusTabs[this.checkIndex].count = length
        },

        getVideoData() {
            let success = (res) => {
                this.setTaskTypeCount(res.data.data.length)
                this.videoListData = res.data.data;
                this.total_number = parseInt(res.data.data_sum);
                this.page_index = parseInt(res.data.page_index);
                this.placeholder = this.videoListData.length === 0;
                this.videoListData.forEach((item) => {
                    if (!item.avatar_path.includes("http")) {
                        item.avatar_path = this.BASE_URL + item.avatar_path;
                    }
                });
            };
            this.$ajax({
                url: "/api/assignment/assignment_list",
                method: "get",
                params: {
                    keyword: this.keyword,
                    page_index: this.page_index,
                    page_size: this.page_size,
                    user_id: this.$g.user_id,
                    is_limit: 1,
                    select_type: this.checkIndex,
                },
                func: {
                    success,
                },
            });
        },
        change_page(val) {
            this.page_index = val;
            this.getVideoData();
        },
    },
};
</script>
<style lang="scss">
.openclass-list .pageBox {
    margin-bottom: 20px;
}



.video-type {
    margin-top: 20px;
    padding: 23px 36px;
    font-size: 14px;
    background: #fff;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;

    >dt {
        margin-right: 14px;
        min-width: 72px;
        height: 30px;
        line-height: 30px;
        color: #888888;
    }

    >dd {
        float: left;
        margin-right: 30px;
        padding: 0 10px;
        line-height: 30px;
        cursor: pointer;

        &.active {
            color: #E62125;
            // background: #0059AA;
        }

        &:hover {
            color: #E62125;
        }
    }
}

.course-kard {
    padding: 20px 20px 13px 20px;
    background: #ffffff;
    margin: 0 0 40px;
    -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    border-top: 3px;
}

.course-content {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 10px;
}

.course-content>span {
    display: block;
    float: left;
    color: #666666;
    width: 60px;
    overflow: hidden;
    height: 19px;
    text-align: left;
}

.course-content:last-of-type {
    margin-bottom: 0;
}

.course-list {
    margin-left: 60px;
    min-height: 29px;
}

.course-list>label {
    float: left;
    color: #000000;
    cursor: pointer;
    margin: 0 3.7735849057% 10px 0;
}

.course-list>label>input:checked+span {
    color: #E62125;
}

.course-list>label input {
    display: none;
}

.course-list>label:hover {
    color: #61a4f5;
}

.course-kard {
    margin: 20px 0;
    overflow: hidden;
}

.carousel-part {
    margin: auto;

    .caurse-carousel {
        display: inline-block;
        width: 100%;
        height: 400px;

        .el-carousel {
            border-radius: 3px;
        }

        .el-carousel__container {
            width: 100%;
        }

        img {
            height: 100%;
            width: 100%;
            object-fit: fill;
        }

        .el-carousel__indicator .el-carousel__button {
            width: 8px;
            height: 8px;
            border-radius: 50%;
        }
    }

    .popularity-list {
        display: inline-block;
        width: 320px;
        background-color: #fff;

        .humantitle {
            // padding: 5px 8px;
            // border-radius: 2px;
            font-size: 14px;
            // color: #fff;
            // background-color: #338efc;
            color: #666;
            line-height: 18px;
        }

        .el-card__header {
            padding: 10px 17px 15px;
            // margin: 0 8px;
            border-bottom: solid 2px #e5e5e5;
            border-bottom: none;
        }

        .el-card__body {
            height: 299px;
            padding: 15px 20px 20px;
            padding: 0 17px;
            height: 355px;
        }

        .humanItem {
            padding: 5px 0;
        }

        .humanItem i {
            border-radius: 4px;
            vertical-align: middle;
        }

        .humanItem a {
            display: inline-block;
            width: 80%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 20px;
            font-size: 14px;
            color: #020202;
            vertical-align: middle;
        }

        .humanItem:hover {
            background-color: #effaff;
        }

        .humanItem:hover>a {
            color: #E62125;
        }

        .humanNun {
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #ffffff;
            background: #d2d2d2;
            margin-right: 10px;
        }

        .humanNun.yellowC {
            background: #f2b732;
        }
    }
}

.course-video-con {
    margin: auto;
    margin-top: 7%;
}

.tabs {
    display: flex;
    height: 40px;
    padding-bottom: 20px;

    div {
        line-height: 40px;
        font-size: 18px;
        padding-right: 40px;

        span {
            padding: 10px 20px;
        }
    }

    .acitvetab {
        background-color: #fef2f2;
        border: #e62126 1px solid;
        color: #e62126;
        border-radius: 10px;
    }
}


.course-video-list {
    position: relative;

    .course-video-li {
        float: left;
        width: 290px;
        border-radius: 3px;
        // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
        overflow: hidden;
        margin: 0 13px 20px 0;
        background: #fff;

        -moz-transition: all 0.35s ease-in;
        -webkit-transition: all 0.35s ease-in;
        -o-transition: all 0.35s ease-in;
        transition: all 0.35s ease-in;
        position: relative;

        .course-video-li .video-creater-info>a,
        .course-video-li .video-creater-info>p {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .red_dot {
        width: 7px;
        height: 7px;
        background-color: red;
        border-radius: 30px;
        left: 2px;
        top: 0%;
        z-index: 9999999;
        position: absolute;
    }

    .course-video-li:hover {
        -webkit-box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
    }

    .course-video-li .video-thumbnail {
        height: 140px;
        display: block;
        overflow: hidden;
    }

    .course-video-li .video-thumbnail a,
    .course-video-li .video-thumbnail img {
        width: 100%;
        height: 100%;
        vertical-align: top;
    }

    .speed {
        width: 80px;
        position: absolute;
        left: 5px;
        top: 5px;
        z-index: 999999;

        span {
            width: 80px !important;
            text-align: center;
        }
    }

    .status_tag {
        width: 80px;
        position: absolute;
        right: -15px;
        top: 5px;
        z-index: 999999;
    }


    .video-thumbnail a {
        position: relative;
    }

    .video-thumbnail a::after {
        content: "";
        opacity: 0;
        background: linear-gradient(180deg,
                rgba(0, 0, 0, 0.01) 2%,
                rgba(0, 0, 0, 0.2));
        transition: opacity 0.4s ease-in-out;
        position: absolute;
        top: 2px;
        left: 0;
        width: 100%;
        height: 140px;
    }

    .video-thumbnail:hover>a:after {
        opacity: 1;
    }

    .course-video-li .video-creater-info {
        padding: 0 10px 20px;
        background: #ffffff;
    }

    .course-video-li .video-creater-info>a {
        font-size: 14px;
        color: #020202;
        line-height: 20px;
        padding-top: 13px;
        display: block;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .course-video-li .video-creater-info .course-video-li:hover {
        box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
    }

    .course-video-li .video-creater-info {
        font-size: 16px;
        color: #666666;
    }

    .course-video-li:nth-of-type(4n) {
        margin: 0 0 18px 0;
    }

    .teacher-info {
        display: flex;
        margin-top: 14px;
        height: 25px;
        line-height: 25px;
        font-size: 14px;

        >span {
            display: inline-block;
            width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .acatar_img {
            display: inline-block;
            // vertical-align: middle;
            width: 25px;
            height: 25px;
            -moz-border-radius: 50%;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 5px;
        }

        .ecmapper {
            text-align: right;
            width: 115px;
            white-space: nowrap;
            overflow: hidden;

            text-overflow: ellipsis;
        }

        >div>span {
            font-size: 12px;
        }

        .collection08,
        strong {
            vertical-align: middle;
        }

        strong {
            margin-left: 5px;
        }
    }
}

.is-nice {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../../../assets/images/openclassQuality.png") no-repeat;
}

.dependent {
    // background-color: #fff;
    text-align: center;
    overflow: hidden;
    margin-bottom: 50px;
    padding-top: 30px;

    p {
        color: #999;
        margin: 40px 0;
    }
}
</style>
  